var React = require('react');

function IcoBus (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("circle",{"fillRule":"evenodd","clipRule":"evenodd","cx":"72.9","cy":"67.5","r":"6.7","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M19.1,60.1c-3.9,0-7,3.1-7,7c0,3.9,3.1,7,7,7c3.9,0,7-3.1,7-7\n\t\tC26.1,63.2,22.9,60.1,19.1,60.1z","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M92,23.5H-0.1v44h4h5.8c0,0,0-0.3,0-0.4c0-5.1,4.1-9.2,9.2-9.2S28,62,28,67.1\n\t\tc0,0.1,0,0.4,0,0.4h35.8c0-5,4.1-9.1,9.2-9.1c5,0,9.1,4.1,9.2,9.1h0.2h4.6h1h12V29.6C99.9,29.6,100.2,23.5,92,23.5z M83.9,29.4v16\n\t\tl-25,0.1v-16L83.9,29.4z M55.9,29.5v16l-25-0.1v-16L55.9,29.5z M2.9,45.5v-16h25v16H2.9z M96.9,61.5h-10v-6v-26h10V61.5z","key":2})]));
}

IcoBus.displayName = "IcoBus";

IcoBus.defaultProps = {"className":"icon icoBus","version":"1.1","id":"Ebene_1","x":"0px","y":"0px","viewBox":"0 0 100 100","enableBackground":"new 0 0 100 100","xmlSpace":"preserve"};

module.exports = IcoBus;

IcoBus.default = IcoBus;
